module.exports = __webpack_public_path__ + "img/work4.1a5d8ecc.svg";